class Outputs {
  reply = '';

  constructor(answer) {
    this.reply = answer;
  }
}
export default Outputs;
